// ============================================================================
// 스탁 분류 (2026-09-09 ARB 추가)
//
//   Banking_Info.Master 컬럼 값
//     '1' Master  (MCB · Master Cell Bank)
//     '0' Working (WCB · Working Cell Bank)
//     '2' ARB     (Assay Ready Bank)
//
//   기존에는 Master 여부를 체크박스로 받고 masterY/masterN 이미지로 켜짐/꺼짐을
//   표시했다. 3종이 되면서 on/off 방식이 성립하지 않으므로 M / W / A 글자 배지로 바꿨다.
//
//   서버측 라벨은 server/guest_web/organoid_info.js 의 STOCK_LABEL 과 짝이다.
//   값을 추가하거나 라벨을 바꿀 때 양쪽을 함께 고쳐야 한다.
//   (서버는 결재 카테고리 문자열을 이 라벨로 만들고, util.js 가 'master'/'arb'
//    포함 여부로 결재자를 정한다)
// ============================================================================

export const STOCK_TYPES = [
    { value: '1', code: 'M', label: 'Master',  full: 'Master Stock (MCB)',  color: '#E78E38' },
    { value: '0', code: 'W', label: 'Working', full: 'Working Stock (WCB)', color: '#8A9099' },
    { value: '2', code: 'A', label: 'ARB',     full: 'Assay Ready Bank',    color: '#2F80ED' },
];

/** Master 값(문자/숫자/undefined) → 분류 객체. 모르는 값은 Working 으로 본다. */
export const stockOf = (v) => {
    const key = String(v === null || v === undefined ? '0' : v);
    return STOCK_TYPES.find((t) => t.value === key) || STOCK_TYPES[1];
};

/** 화면 표시용 라벨 ('Master' / 'Working' / 'ARB') */
export const stockLabel = (v) => stockOf(v).label;
